import React, { useEffect, useState } from "react";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import { useAppDispatch, useAppSelector } from "../../useStore";
import OfferedTable from "./ApplicantTableComponent/OfferedTable";
import swal from "sweetalert";

const ApplicantOffered = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();


  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "OFFERED" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, UpdateOfferisSuccess, dispatch, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);




  useEffect(() => {
    const input = { applicationStatus: "OFFERED" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch]);


  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])






  return (
    <div>
      <OfferedTable
        statusButton={"view-OFFERED-status"}
        pageHeader={"Offered"}
        headerTitles={[
          "",
          "Edit",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Update Offer",
          "Job Profile",
          "View ID",
          "Applied on",
          "Status",
          "Email",
          "Phone Number",
          "Average Interview Score",
          "Work Experience",
          "Relevant Work Experience",
          "Location",
          "Edit"
        ]}
        data={data}
        isLoading={isLoading}
        message={message}
        isError={isError}
        setResetID={setResetID}
      />
    </div>
  );
};

export default ApplicantOffered;
